import useOfferCardFacilities from 'hooks/Offers/useOfferCardFacilities'
import OfferCardFacilities from './OfferCardFacilities'
import type { ReactNode } from 'react'

interface Props {
  offerId: string
  filters?: App.OfferListFilters
  fallbackFacilities: Array<App.OfferInclusion>
  children?: ReactNode
  size?: 'small' | 'medium'
}

function OfferCardFacilitiesFallback({ offerId, filters, fallbackFacilities, children, size }: Props) {
  const { facilities, ref } = useOfferCardFacilities(offerId, filters, fallbackFacilities)

  return <div ref={ref}>
    {facilities.length > 0 ? <OfferCardFacilities facilities={facilities} size={size} /> : children}
  </div>
}

export default OfferCardFacilitiesFallback
